export enum ReasonsForCancelEOI {
  UNABLE_TO_OBTAIN_FINANCE = "Unable to obtain finance",
  CHANGE_OF_MIND = "Change of mind",
  MOVED_TO_DIFFERENT_LOT = "Moved to different lot",
  OTHER = "Other",
}
